import { typeConfig } from '@/components/survey-detail/config/index.js'

export function textColor(status) {
  let color = ''
  if(typeConfig[status].tagType === 'warning') {
    color = '#e8a31b'
  } else if(typeConfig[status].tagType === 'success') {
    color = '#00be6a'
  } else if(typeConfig[status].tagType === 'danger') {
    color = '#E34152'
  } else if(typeConfig[status].tagType === 'info') {
    color = '#6c748a'
  }
  return color
}